module.exports = __webpack_public_path__ + "img/empty.f484c97a.svg";